// extracted by mini-css-extract-plugin
module.exports = {"EditButton":"style_EditButton__2PHpV","text":"style_text__yi2li"};